<template>
  <footer class="n3-pie" v-if="NOTARIA?.Theme">
    <div class="n2-contenedor">
      <div class="n3-pie__grande">
        <p class="n3-pie__antetitulo">{{ T.Footer?.TituloDContacto?.Texto || tituloSeccion(NOTARIA, 'Contacto', $t) }}</p>
        <a v-if="C.Telefono" class="n3-pie__telefono" :href="'tel:' + C.Telefono.replace(/\s/g, '')">{{ C.Telefono.trim() }}</a>
        <a v-if="C.Email" class="n3-pie__email" :href="'mailto:' + C.Email">{{ C.Email }}</a>
      </div>

      <div class="n3-pie__rejilla">
        <div v-if="C.Direccion">
          <p class="n3-pie__titulo">{{ NOTARIA.Nombre }}</p>
          <a :href="C.EnlaceMaps || undefined" target="_blank" rel="noopener">
            {{ C.Direccion }}<br>{{ [C.CP, C.Municipio].filter(Boolean).join(' ') }}<template v-if="C.Provincia && C.Provincia !== C.Municipio"> ({{ C.Provincia }})</template>
          </a>
          <p v-if="C.Movil || C.Email2" class="n3-pie__extra">
            <a v-if="C.Movil" :href="'tel:' + C.Movil.replace(/\s/g, '')">{{ C.Movil.trim() }}</a><br v-if="C.Movil && C.Email2">
            <a v-if="C.Email2" :href="'mailto:' + C.Email2">{{ C.Email2 }}</a>
          </p>
        </div>
        <div v-if="C.Horario">
          <p class="n3-pie__titulo">{{ T.Footer?.TituloHorario?.Texto || tSolicitud('Horario') }}</p>
          <p class="n2-pre">{{ C.Horario }}</p>
        </div>
        <div>
          <ul class="n3-pie__menu">
            <li v-for="e in enlaces" :key="e.clave">
              <a v-if="e.externo" :href="e.href" target="_blank" rel="noopener">{{ e.texto }}</a>
              <NuxtLink v-else :to="e.to">{{ e.texto }}</NuxtLink>
            </li>
            <li v-if="acceso.visible('pie')"><NuxtLink :to="acceso.enlace('pie')">{{ tSolicitud('Encargo online') }}</NuxtLink></li>
          </ul>
        </div>
        <div v-if="T.Footer?.MostrarMapa && urlMapa" class="n3-pie__mapa">
          <iframe :src="urlMapa" :title="'Mapa de ' + NOTARIA.Nombre" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>

      <div class="n3-pie__legal">
        <div class="n2-redes">
          <a v-for="r in redes" :key="r.icono" :href="r.url" target="_blank" rel="noopener" :aria-label="r.nombre + ' de ' + NOTARIA.Nombre">
            <v-icon size="20">{{ r.icono }}</v-icon>
          </a>
        </div>
        <nav>
          <span>© {{ new Date().getFullYear() }} {{ NOTARIA.Nombre }}</span>
          <a :href="getLocalePath('/avisolegal')">{{ $t('avisoLegal') }}</a>
          <a :href="getLocalePath('/politicacookies')">{{ $t('politicaCookies') }}</a>
          <a :href="getLocalePath('/protecciondatos')">{{ $t('proteccionDatos') }}</a>
          <a :href="getLocalePath('/accesibilidad')">{{ $t('accesibilidad') }}</a>
          <a v-if="NOTARIA.UrlDenuncias" :href="urlExterna(NOTARIA.UrlDenuncias)" target="_blank" rel="noopener">{{ $t('denuncias') }}</a>
          <a href="https://controlpanel.unidata.es/">{{ $t('panelControl') }}</a>
        </nav>
      </div>
      <div v-if="T.Footer?.MostrarSubFooter" class="n3-pie__sub"><FooterSubFooter /></div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { tituloSeccion, urlExterna, useMenuNotaria } from '../../composables/useNotaria2'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { $t, getLocalePath } = useUtils()
const acceso = useAccesoSolicitud()
const { enlaces } = useMenuNotaria()

const T = computed(() => NOTARIA.value?.Theme ?? {})
const C = computed(() => NOTARIA.value?.Contacto ?? {})
const redes = computed(() => [
  { url: C.value.Facebook, icono: 'mdi-facebook', nombre: 'Facebook' },
  { url: C.value.LinkedIn, icono: 'mdi-linkedin', nombre: 'LinkedIn' },
  { url: C.value.Twitter, icono: 'mdi-twitter', nombre: 'X' },
  { url: C.value.Instagram, icono: 'mdi-instagram', nombre: 'Instagram' },
].filter(r => r.url))
const urlMapa = computed(() => {
  const c = C.value.Coordinates
  return c && Number(c.lat) && Number(c.lng) ? `https://maps.google.com/maps?q=${c.lat},${c.lng}&z=15&output=embed` : ''
})
</script>
